import React, { ReactNode } from "react";
import { Box } from "flicket-ui";
import { motion, AnimatePresence } from "framer-motion";
import styled from "styled-components";

type OptionsProps = {
  showOptions: boolean;
  children: ReactNode;
};

const MotionBox = motion.custom(Box);

const AnimatedMenu = styled(MotionBox)`
  border-radius: 12px 12px 0 0;

  width: 100%;

  background: ${(p) => p.theme.colors.white};

  box-shadow: 0px -2px 28px rgba(0, 0, 0, 0.05),
    0px -0.835552px 16px rgba(0, 0, 0, 0.0403),
    0px -0.446726px 10.7214px rgba(0, 0, 0, 0.03),
    0px -0.250431px 6.01034px rgba(0, 0, 0, 0.025),
    0px -0.133002px 3.19205px rgba(0, 0, 0, 0.0183),
    0px -0.0553451px 1.32828px rgba(0, 0, 0, 0.0097);
`;

export const MobileOptions = ({ showOptions, children }: OptionsProps) => {
  return (
    <AnimatePresence>
      {showOptions && (
        <Box
          position="fixed"
          w="100%"
          bottom={0}
          d={{ _: "flex", md: "none" }}
          // + 1 zIndices overlay (1300)
          zIndex={1301}
        >
          <AnimatedMenu
            initial={{ height: 0 }}
            animate={{ height: "auto" }}
            exit={{ height: 0 }}
          >
            {children}
          </AnimatedMenu>
        </Box>
      )}
    </AnimatePresence>
  );
};
